module.exports = __webpack_public_path__ + "static/the-warmth-of-other-suns-3327f7b4d53f6085c2ea011e9b810731.jpg";